import { FB_FUNCTIONS_URL } from "../shared/constants";

export class StripeService {
  static async createStripeAccount() {
    const createAccountUrl = `${FB_FUNCTIONS_URL}/stripe/create-account`;

    try {
      const account = await fetch(createAccountUrl, {
        method: 'POST'
      }).then(res => res.json());
      return account;
    } catch (err) {
      return null;
    }
  }

  static async getAccountData(accountId) {
    const accountUrl = `${FB_FUNCTIONS_URL}/stripe/account/${accountId}`;

    try {
      const account = await fetch(accountUrl).then(res => res.json());
      return account;
    } catch (err) {
      return null;
    }
  }

  static async getAccountLink(accountId) {
    const accountUrl = `${FB_FUNCTIONS_URL}/stripe/account-link/${accountId}`;

    try {
      const account = await fetch(accountUrl).then(res => res.json());
      return account;
    } catch (err) {
      return null;
    }
  }

  static async createPayment(body) {
    return fetch(`${FB_FUNCTIONS_URL}/stripe/create-payment-intent`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(res => res.json())
      .then(data => {
        const clientSecret = data.clientSecret;
        return clientSecret;
      })
      .catch(err => {
        return null;
      });
  }

  static async createTransfer(body) {
    return fetch(`${FB_FUNCTIONS_URL}/stripe/create-transfer`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(res => res.json())
      .catch(err => {
        return null;
      });
  }
}
